module.exports = __webpack_public_path__ + "static/media/Facetime.96d34959.png";